<template>
  <div>
    <el-dialog :title="dialogTitle" :visible.sync="showDelappoint" width="35%" :close-on-click-modal="false"
      :append-to-body="true" :modal-append-to-body='false' :before-close="handleClose">
      <el-form>
        <el-form-item label="协助下机管理员" label-width="120px">
          <el-input readonly :disabled="dialogTitle == '查看下机信息'" @click.native='toSelect' placeholder="请选择协助下机管理员"
            v-model="selectName"></el-input>
        </el-form-item>
        <el-form-item label="实际检测件数" label-width="120px">
          <el-input :disabled="dialogTitle == '查看下机信息'" placeholder="请填写实际检测件数" v-model="usageCount"></el-input>
        </el-form-item>
        <el-form-item label="设备状态" label-width="120px">
          <el-select :disabled="dialogTitle == '查看下机信息'" v-model="equipmentStatus" placeholder="请选择考核结果">
            <el-option label="正常" value="1"></el-option>
            <el-option label="异常" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="equipmentStatus == '0'" label="异常原因" label-width="120px">
          <el-input :disabled="dialogTitle == '查看下机信息'" placeholder="请填写异常原因"
            v-model="equipmentAbnormalReason"></el-input>
        </el-form-item>
      </el-form>
      <div style='margin-left:15px;margin-bottom:15px'>{{ "图片（必填）：" + uploadFileList.length + "/3" }}
      </div>
      <el-upload v-if="dialogTitle == '填写下机信息'" :action="action" list-type="picture-card" accept=".jpg,.png"
        :headers='uploadData' :limit='3' :on-success='uploadFile' :on-remove='deleteFile'>
        <i class="el-icon-plus"></i>
      </el-upload>
      <div v-else>
        <div v-for='(item, index) in imgsrcList' :key='index' class="demo-image__preview">
          <el-image style="width: 100px; height: 100px" :src="item" :preview-src-list="imgsrcList">
          </el-image>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="dialogTitle == '填写下机信息'" @click="handleClose">取 消</el-button>
        <el-button v-if="dialogTitle == '填写下机信息'" type="primary" @click="delappoint">确 定</el-button>
        <el-button v-if="dialogTitle == '查看下机信息'" @click="handleClose">返回</el-button>
      </span>
    </el-dialog>
    <selectAdmin v-if="showSelectadmin" :showSelectadmin='showSelectadmin' @cancel="cancel" :selectData='selectData'
      @getAdmin='getAdmin' :eqid='eqid' />
  </div>
</template>
<script>
import selectAdmin from './selectAdmin.vue'
const { APIURl } = require('@/utils/apiUrl')
export default {
  components: {
    selectAdmin
  },
  props: {
    showDelappoint: {

    },
    dialogTitle: {

    },
    rowData: {

    }
  },
  data() {
    return {
      reason: '',
      showSelectadmin: false,
      eqid: '',
      usageCount: "",
      selectName: '',
      uploadData: {},
      action: APIURl + '/common/upload',
      phoneNum: 0,
      uploadFileList: [],
      selectData: [],
      assistUserIdList: [],
      imgsrcList: [

      ],
      equipmentStatus: '',
      equipmentAbnormalReason: ''
    }
  },
  methods: {
    handleClose() {
      this.$emit('cancel')
    },
    cancel() {
      this.showSelectadmin = false
    },
    uploadFile(res, file, fileList) {
      this.uploadFileList = fileList

    },
    deleteFile(file, fileList) {
      this.uploadFileList = fileList

    },
    init() {
      this.uploadData.Authorization = window.localStorage.getItem('SDAU_token').split('|')[0]
      if (this.dialogTitle == '查看下机信息') {
        this.usageCount = this.rowData.usageCount
        this.equipmentStatus = String(this.rowData.equipmentStatus)
        this.equipmentAbnormalReason = this.rowData.equipmentAbnormalReason

        if (this.rowData.assistUserInfoList) {
          let arr = []
          this.rowData.assistUserInfoList.forEach((item, index) => {
            arr[index] = item.assistUserName
          })
          this.selectName = arr.join(',')
        }
        else {
          this.selectName = []
        }
        this.rowData.uploadFileList.forEach((item, index) => {
          this.imgsrcList[index] = APIURl + '/' + item.filePath
        })
      }


    },
    getAdmin(data) {
      let arr = []
      data.forEach(item => {
        arr[arr.length] = item.nickName
      })
      this.selectName = arr.join(',')
      this.selectData = data
      this.selectData.forEach(item => {
        this.assistUserIdList.push(item.userId)
      })
    },
    delappoint() {
      if (!this.usageCount) {
        this.$message({
          type: "warning",
          message: "请输入检测件数"
        })
        return
      }
      if (this.uploadFileList.length == 0) {
        this.$message({
          type: "warning",
          message: "请上传图片"
        })
        return
      }
      let form = {
        assistUserIdList: this.assistUserIdList,
        uploadFileList: [],
        equipmentAbnormalReason: this.equipmentAbnormalReason,
        usageCount: this.usageCount,
        equipmentStatus: this.equipmentStatus,
        deviceReservationRecordId: this.rowData.deviceReservationRecordId
      }
      this.uploadFileList.forEach(item => {
        form.uploadFileList.push({ fileName: item.response.fileName, filePath: item.response.url })
      })
      this.$net(`/sdau/deviceReservation/replenishStopUsing`, 'post', form).then(res => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "保存成功"
          })
          this.handleClose()
        }
      })

    },
    toSelect() {
      this.showSelectadmin = true
      this.eqid = this.rowData.equipmentId
    },
  },
  created() {
    this.init()
  }
}
</script>
<style lang="scss" scoped>
.demo-image__preview {
  display: inline-block;
  margin-right: 10px;
}
</style>